<template>
  <div class="bls-code-container">
    <template v-for="code_type in ['Bodypart', 'Event', 'Nature', 'Source']">
      <template v-for="level in availableLevels[code_type]">
        BLS {{ code_type }} {{ labelForLevel(level) }} Category:
        <ChildSelect
          class="child-select"
          :key="`${code_type} - ${level}`"
          :id="`${code_type}-${level}-raft-select`"
          :disabled="disabledFor({ level, code_type }) || disabled"
          :options="
            formattedOptions({
              level: level,
              code_type: code_type,
              parentId: valueFor({
                level: level - 1,
                code_type,
              }),
            })
          "
          :selected-value="getSelectedValue(code_type, level)"
          @select="childSelect"
        />
      </template>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import babelPolyfill from "babel-polyfill";
import ChildSelect from "../fields/ChildSelect.vue";

export default {
  name: "BlsCodeSelects",
  components: {
    ChildSelect,
  },
  data() {
    return {
      fields: {},
      entity: {},
      fieldGroups: [],
      bundleFieldsSorted: [],
      editFields: [],
      formData: {},
    };
  },
  props: {
    values: { type: Object, default: null },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    ...mapActions("incidentManagementStore", [
      "fetchBlsCodes",
      "setResponse",
      "setAlreadySelected",
      "fireAlreadySelected",
      "clearAboveLevel",
    ]),
    labelForLevel: function (level) {
      switch (level) {
        case "1":
          return "Initial";
        case "2":
          return "Second";
        case "3":
          return "Third";
        case "4":
          return "Fourth";
        default:
          return "";
      }
    },
    getSelectedValue: function (codeType, level) {
      if (this.values && this.values.hasOwnProperty(codeType)) {
        return this.values[codeType].find((i) => i.index === level);
      }
      return null;
    },
    childSelect: function (event) {
      const selectionKey =
        event.value.code_type.toLowerCase() + "_" + event.value.level;
      this.formData[selectionKey] = event.value.id;
      this.clearAboveLevel(event.value);
      // Note: eslint complains about the casing on code_type, but object destructuring in this manner
      // requires the variable to match the object property.
      /* eslint-disable camelcase */
      const { level, code_type, code } = event.value;
      for (let i = parseInt(level, 10) + 1; i <= 4; i++) {
        const keyToEmpty = code_type.toLowerCase() + "_" + i;
        if (this.formData[keyToEmpty]) {
          this.formData[keyToEmpty] = null;
        }
        this.setResponse({ level: i, code_type, code });
      }
      /* eslint-enable camelcase */
      this.setResponse(event.value);
      this.$emit("bls-code-selection", this.formData);
    },
  },
  computed: {
    ...mapState("incidentManagementStore", ["blsCodes"]),
    ...mapGetters("incidentManagementStore", [
      "availableLevels",
      "availableOptions",
      "formattedOptions",
      "disabledFor",
      "valueFor",
      "codeForId",
    ]),
  },
  async created() {
    await this.fetchBlsCodes();
  },
  watch: {
    values: {
      immediate: true,
      handler: function (newVal) {
        this.setAlreadySelected(newVal);
      },
    },
    blsCodes: {
      immediate: true,
      handler: function () {
        if (this.values) {
          this.setAlreadySelected(this.values);
        }
      },
    },
  },
};
</script>
<style scoped>
div.bls-code-container {
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  padding-top: 1rem;
}

.child-select {
  margin-bottom: 1rem;
}
</style>
